import { FormCheckboxGroupField } from "../../wsui/form";
import kebabCase from "lodash/kebabCase";
import React from "react";

export default function FormModuleRadioField({
  field: { description, label, required, values },
  ...restProps
}) {
  let name = kebabCase(label);
  let options = values.map(({ value }) => value);

  return (
    <FormCheckboxGroupField
      description={description}
      label={label}
      name={name}
      options={options}
      required={required}
      // className={required && styles.required}
      multiple={false}
      {...restProps}
    />
  );
}
